// ============================================================
// [2.2] URL de l'API vue par l'admin.
// - VITE_API_URL posée au build → utilisée telle quelle (staging, e2e).
// - Sinon, en dev → http://localhost:4000 (comportement historique).
// - Sinon (build servi par le serveur Siverix tout-en-un à /admin/) →
//   même origine que la page : l'admin suit l'adresse du serveur.
// ============================================================

const fromEnv = import.meta.env.VITE_API_URL as string | undefined;

export const API_BASE: string =
  fromEnv !== undefined && fromEnv !== ''
    ? fromEnv.replace(/\/+$/, '')
    : import.meta.env.DEV
      ? 'http://localhost:4000'
      : window.location.origin;
